module.exports = __webpack_public_path__ + "img/COFFEE_MACHINE_AMENITY.0aea8b7e.svg";